// マイページ顧客宛文書詳細
import React, { useState, useEffect } from 'react';
import { render } from 'react-dom';
import { Container, Button } from 'react-bootstrap';
import { Document, Page } from 'react-pdf';
import axios from '../../axios';
import Moment from 'moment';
import Heading from '../../molecules/Heading';
import Paragraph from '../../molecules/Paragraph';
import TransitionButton from '../../molecules/TransitionButton';
import LoadingModal from '../../molecules/LoadingModal';
import { KWANKGM00240A01 } from '../../const/api_modules';
import { isSmartPhone } from '../../BrowserJudgment';
import { handleBrowserBack } from '../../BrowserBack';
import { CustomerDocumentFileDownload } from './CustomerDocumentFileDownload';

const CustomerDocumentMypageDetail = () => {
  // URLパラメータの取得
  const url_params = new URLSearchParams(document.location.search.substring(1));
  const document_id = url_params.get('id');

  const [is_loading, setIsLoading] = useState(false);

  // 画面出力用State
  const [start_date, setStartDate] = useState<Date|string>('');
  const [end_date, setEndDate] = useState<Date|string>('');
  const [title, setTitle] = useState('');
  const [comment, setComment] = useState('');
  const [file_name, setFileName] = useState<string|null|undefined>('');

  // pdfビューワー出力
  const [pdf_url, setPdfUrl] = useState('');
  const [numPages, setNumPages] = useState(1);
  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
  };

  // TODO モック
  const mock = {
    data: {
      result: true,
      message: '',
      id: 1,
      title: '融資実行のご案内',
      comment: '融資実行が完了しました。詳細内容については添付ファイルをご確認ください。添付ファイルは、ダウンロードすることができます。',
      file_name: '',
      start_date: '2022-04-01',
      end_date: '2022-05-30',
      pdf_file: '',
    }
  };

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
    // 初期データを読み込む
    requestModule();
  }, []);

  const requestModule = async () => {
    try {
      setIsLoading(true);

      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/api/common`, {
        module_name : KWANKGM00240A01,
        is_json : true,
        reception_id : '0',
        reception_cd : null,
        detail : [
          { id: 0, name: 'id', value: document_id }
        ],
      });

      if (!response.data.result) {
        throw({response: response});
      }

      setStartDate(new Date(response.data.detail.customer_document.start_date));
      if (response.data.detail.customer_document.end_date !== null) {
        setEndDate(new Date(response.data.detail.customer_document.end_date));
      }
      setTitle(response.data.detail.customer_document.title);
      setComment(response.data.detail.customer_document.comment);
      setFileName(response.data.detail.customer_document.file_name);

      if (response.data.detail.customer_document.file_name.match('\.pdf$')) {
        setPdfUrl(`data: pdf;base64, ${response.data.detail.customer_document.pdf_file}`);
      }
    } catch (error) {
      console.error(error.response.data.message);
      alert(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  // PDFビューワを表示する
  const visiblePdfViewer = () => {
    if (pdf_url !== null && typeof pdf_url !== 'undefined' && pdf_url.length > 0) {
      return (
        <Document
          file={pdf_url}
          onLoadSuccess={onDocumentLoadSuccess}
          loading={<LoadingModal show={true} />}
          error=""
          noData=""
          options={{
            cMapUrl: '/cmaps/',
            cMapPacked: true,
          }}
        >
          <div className="pdf_viewer">
            {Array.from(new Array(numPages), (el, index) => (
              <Page
                key={index}
                pageNumber={index + 1}
                className="pdf_viewer_page"
                width={isSmartPhone() ? 350 : 800}
              />
            ))}
          </div>
        </Document>
      );
    }

    // pdf_urlが空の場合はビューワーを表示しない
    return (<></>);
  }

  // 戻るボタン押下時の処理
  const handleClickReturn = () => {
    location.replace(`${location.origin}${process.env.MIX_MOCK_URL}/mypage/list`);
  };

  // 添付ファイルの有無によって表示を切り分ける
  const visibleDownloadButton = () => {
    if (file_name === null || typeof file_name === 'undefined' || file_name.length === 0) {
      return <></>;
    }
    return(
      <>
        <div className="p-lead">
          <Paragraph label="添付ファイルは、ダウンロードすることができます。" is_paragraph={true} />
        </div>
        <div><b>ファイル名：{file_name}</b></div>
        <div>
          <Button
            onClick={() => CustomerDocumentFileDownload(Number(document_id), setIsLoading, false)}
            className="btn-max"
            size="lg"
            variant="custom"
            disabled={false}
          >
            ダウンロード
          </Button>
        </div>
      </>
    );
  };

  return (
    <div>
      <div className="content">
        <Heading label="マイページ" size="l" />
        <Container>
          <Heading label="ご案内" size="m" />
          <div className="text-right">
            <div>掲載開始日:{Moment(start_date).format('YYYY年M月D日')}</div>
            <div>掲載終了日:{Moment(end_date).format('YYYY年M月D日')}</div>
          </div>
          <Paragraph label="お知らせがございます。下記内容をご確認下さい。" is_paragraph={true} />
          <div className="p-lead">
            <div className="bunsho-title">{title}</div>
          </div>
          <div className="p-lead">
            <div className="bunsho-comment">
              {comment}
            </div>
          </div>
          {visiblePdfViewer()}
          {visibleDownloadButton()}
          <TransitionButton
            label="戻る"
            btn_class="btn-return"
            handleClick={handleClickReturn}
          />
        </Container>
      </div>
      <LoadingModal show={is_loading} />
    </div>
  );
};

if (document.getElementById('mypage-customer-document-detail')) {
  render(<CustomerDocumentMypageDetail />, document.getElementById('mypage-customer-document-detail'));
}
